import styled from '@emotion/styled';

export const ContentContainer = styled('div')(() => ({
  display: 'block',
  maxWidth: '142rem',
  position: 'relative',
}));

export default ContentContainer;
